import React from "react";

const YouTubeIcon = ({ size = "20", color = "#AEAEAE" }: any) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M23.498 6.186a2.993 2.993 0 0 0-2.107-2.12C19.505 3.5 12 3.5 12 3.5s-7.505 0-9.391.566a2.993 2.993 0 0 0-2.107 2.12A31.18 31.18 0 0 0 .5 12a31.18 31.18 0 0 0 .002 5.814 2.993 2.993 0 0 0 2.107 2.12C4.495 20.5 12 20.5 12 20.5s7.505 0 9.391-.566a2.993 2.993 0 0 0 2.107-2.12A31.18 31.18 0 0 0 23.5 12a31.18 31.18 0 0 0-.002-5.814zM9.75 15.5v-7l6 3.5-6 3.5z" />
    </svg>
  );
};

export default YouTubeIcon;
